import {Fragment} from 'react'
import PropTypes from 'prop-types'

import './FreelancePage.scss'

export default function FreelancePage({children, className, style, ...props}) {
  const handleStyle = () => {
    const styleAttr = (style)? style : {}

    return {
      ...styleAttr,
    }
  }

  return (
    <Fragment>
      <div className={`fl-pages py-5 px-3 px-md-5 ${className ? className : ''}`}  {...props} style={handleStyle()} >
        {children}
      </div>
    </Fragment>
  )}

FreelancePage.propTypes = {
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.element),
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.element.isRequired,
    PropTypes.node.isRequired
  ]),
  className: PropTypes.string
}
